import React, { useState } from "react";
import { Box, TextField, Button, Typography, Grid2, InputAdornment , IconButton } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import LogoIcon from "../../assets/images/LogoIcon.svg";
import LogoText from "../../assets/images/LogoText.svg";
import mail from "../../assets/images/email.svg";
import edit from "../../assets/images/edit.svg";
import passwordimg from "../../assets/images/passwordimg.svg";
import rightArrow from "../../assets/images/right.svg";
import fullName from "../../assets/images/full-name.svg";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../utils/Snackbars";
import useRequestsWOAccessToken from "../../utils/useRequestsWOAccessToken";

const ChangePhone = () => {
    const Back = () => {
    const params = location.search ? location.search : "";
    navigate(`/verify-phone${params}`,{
        state:{
            email:location.state?.email || "",
            phone:location.state?.phone || "",
            // variant: "success",
            // message: "update your email",
        }
    })
  };
  const navigate = useNavigate();
  const location = useLocation();
  const phone = location.state?.phone || ""; // Get the email passed from Forgot Password page
  const { postRequestWOAccessToken } = useRequestsWOAccessToken();
  // const [formData, setFormData] = useState({
  //     fullName:" ",
  //     email:"",
  // });
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      oldphone: location.state?.phone,
      phone: phone,
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit phone number!')
        .required('Phone number is required'),
    }),
    onSubmit: async (values) => {
      // e.preventDefault();
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";

        const jsonpar = JSON.stringify({
          phone: values.phone,
          oldphone: location.state?.phone,
        });
        const res = await postRequestWOAccessToken("auth/change-phone", jsonpar);
        if (res && res.code === 200) {
          // setFormData({
          //     old_password: "",
          //     new_password: "",
          //     new_confirm_password: "",
          // });
          const params = location.search ? location.search : "";
          navigate(`/verify-phone${params}`, {
            state: {
              phone:values.phone,
              email: location.state?.email,
              variant: "success",
              message: res.message,
            },
          });
        } else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }));
        }
        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = "submit";
      } catch (error) {
        console.error("Error : ", error);
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "An error occurred while verifing the user.",
        }));
        resetAlertData();
      }
    },
  });


  const handleResendOTP = async () => {
    try {
      let submit2 = document.getElementById("submit2");
      submit2.disabled = true;
      submit2.classList.add("disabled-button");

      const jsonpar = JSON.stringify({
        phone: phone
      });
      const response = await postRequestWOAccessToken(`auth/resend-register-verification-otp-phone`, jsonpar);
      if (response.code === 200 && response.data) {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "success",
          message: response.message
        }));
        resetAlertData();
      } else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: response.message
        }));
        resetAlertData();
      }
      submit2.disabled = false;
      submit2.classList.remove("disabled-button");
      } catch (error) {
          setAlertData({ variant: "error", message: "Something went wrong!" });
      }
  };

  React.useEffect(() => {
    if (location.state && typeof location.state.message !== "undefined") {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
    }
  }, []);

  return (
    <Grid2>
      {/* <Link className="skip" to="/">
        Skip <img src={rightArrow} alt="" />
      </Link> */}
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(98vh - 33px)",
        }}
      >
        <Box
          sx={{
            width: 500,
            padding: 4,
            borderRadius: 2,
            backgroundColor: "#fff",
            textAlign: "center",
          }}
        >
          <Grid2 className="fullLogo">
            <div className="centerLogo">
              <img
                src={LogoIcon}
                alt="Logo"
                width={80}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <div className="centerLogo">
              <img src={LogoText} alt="Logo" width={180} />
            </div>
          </Grid2>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            className="signin-title"
          >
            Update Phone Number
          </Typography>
          <form className="loginForm">
            <div className="position-relative password-field">
              <img
                src={mail}
                alt="Logo"
                width={24}
                className="textboxLefticon"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Phone"
                autoComplete="off"
                name="phone"
                type="number"
                onChange={validation1.handleChange}
                className={`form-control ${
                  validation1.touched.phone && validation1.errors.phone
                    ? "is-invalid"
                    : ""
                }`}
                value={validation1.values.phone || ""}
                invalid={
                  validation1.touched.phone && validation1.errors.phone
                    ? true
                    : false
                }
              />

              {validation1.touched.phone && validation1.errors.phone ? (
                <div className="invalid-feedback">
                  {validation1.errors.phone}
                </div>
              ) : null}
            </div>


            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
              type="submit"
              id="submit1"
              className="btn-common btn bg-primary text-white btn-block"
              onClick={(e) => {
                e.preventDefault();
                validation1.handleSubmit();
                return false;
              }}
            >
              {"Update"}
            </Button>
          </form>
        </Box>
      </Box>
      <Typography className="dont">
        <Link onClick={Back}>Back</Link>
      </Typography>
    </Grid2>
  );
};
export default ChangePhone;
